'use client'

import { REQUEST_PARTIAL_VALIDATION_EVENT } from '../../../../constants/custom-event-names'
import {
    ContainersForValidatableInputs,
    getArrayOfValidatableInputsFromSource,
} from '../../../../helpers/getArrayOfValidatableInputsFromSource'
import { InputWithValidation, RequestValidationEventDetail } from '../../../../types/EventDetailTypes'
import { RefObject, useEffect } from 'react'
import { assertIsCustomEvent } from '../../../use-validate-schema/helpers/assertIsCustomEvent'
import { TypeOfValidations } from '../../../../constants/validation-constants'
import { assert } from '../../../../../Helpers/logging'

const cancelUnnecessaryValidation = (inputs: InputWithValidation[], signal: AbortSignal) => {
    inputs.forEach((input) => {
        input.addEventListener(
            REQUEST_PARTIAL_VALIDATION_EVENT,
            (event) => {
                const customEvent = event as CustomEvent<RequestValidationEventDetail>
                assertIsCustomEvent(customEvent)
                if (customEvent.detail?.typeOfValidation !== TypeOfValidations.SILENT) {
                    return
                }
                if (customEvent.detail?.hasCustomValidation) {
                    return
                }

                // make sure that no custom validity is messing with validation of standard constraints
                ;(customEvent.target as InputWithValidation).setCustomValidity('')

                event.stopPropagation()
            },
            { signal },
        )
    })
}

/**
 * @memberof useValidationOnFields
 * */
export const useCancelUnnecessaryValidation = (
    source: NodeList | null | RefObject<ContainersForValidatableInputs | null>,
) => {
    useEffect(() => {
        if (!source) {
            return
        }
        const inputs = getArrayOfValidatableInputsFromSource(source)
        assert(!!inputs, 'Could not retrieve form inputs from form. Are you sure the form exists')
        if (!inputs) {
            return
        }

        const controller = new AbortController()
        cancelUnnecessaryValidation(inputs, controller.signal)
        return () => {
            controller.abort()
        }
    }, [source])
}
